import { z } from 'zod';

export const ZInstagramMedia = z.object({
  id: z.string(),
  caption: z.string().optional(),
  media_type: z.enum(['IMAGE', 'VIDEO', 'CAROUSEL_ALBUM']).optional(),
  media_url: z.string().optional().nullable(),
  thumbnail_url: z.string().optional(),
  permalink: z.string(),
  timestamp: z.string(),
});

export const ZInstagramLatestPostsResponse = z.object({
  latestPosts: z.array(ZInstagramMedia),
});

export type TInstagramMedia = z.infer<typeof ZInstagramMedia>;
export type TInstagramLatestPostsResponse = z.infer<
  typeof ZInstagramLatestPostsResponse
>;
